import dayjs from 'dayjs';
import React, { memo } from 'react';
import useRedirect from '../../customHooks/useRedirect';
import DoctorsSectionForCard from '../../DoctorSectionForCard/DoctorsSectionForCard';
import { ClockCircleOutline, IoVideocam, MdOutlineArrowRightAlt } from '../../icons';
import ShareCard from '../../ShareCard';
import './css/_liveCmeCardV2.scss';
import { reactHtmlParser } from '../../../common/common';

function LiveCmeCardV2({
  gtmTagVariable = '',
  id,
  category,
  startDate,
  url,
  title,
  session_doctor_entities,
  withOutButton = false,
  cardClick,
  isButton = true,
  isLive = false,
  session_status
}) {
  const { redirectTo } = useRedirect();
  const click = () => {
    cardClick ? cardClick() : redirectTo('SessionDetails', id, title);
  };

  return (
    <div className="w-100 liveCmeCardV2Box bg-white shadow rounded-3 position-relative overflow-hidden">
      <div
        className={`liveCmeCardTop w-100 d-flex justify-content-between align-items-center ${isLive ? '' : 'bg-body p-md-4'
          } p-3 `}
      >
        {category && (
          <h5 className="fs-4 text-black d-inline-flex align-items-center gap-2">
            <i className={`flaticon-video-camera fs-2 text-secondary me-3`}></i>
            {category}
          </h5>
        )}
        {isLive ? (
          <div className="w-100 d-flex justify-content-between align-items-center">
            <div className="live d-flex align-items-center">
              <span className="text-danger fs-16 fw-semibold d-flex align-items-center">
                <div className="pulseCircle me-2"></div> Live
              </span>
            </div>
            <button className="btn btn-secondary px-3 py-2" onClick={click}>
              Join Now
            </button>
          </div>
        ) : (
          <ShareCard
            customClass={`fs-2 text-black ${gtmTagVariable}_LiveCmeCardV2_share`}
            data={{ url, title }}
          />
        )}
      </div>
      <div className="liveCmeCardBtm w-100 float-start text-start p-3 p-md-4">
        {startDate && (
          <h6 className="fs-4 text-dark mb-3">
            <i
              className={`flaticon-clock fs-3 text-dark text-dark me-3 d-inline-block align-middle`}
            ></i>
            <span>{dayjs(startDate).format('ddd, D MMM')}</span> <span className="mx-2">|</span>
            {dayjs(startDate).format('hh:mm A')}
          </h6>
        )}
        <h4
          className={`fs-16 fw-medium text-black line-clamp-2 mb-4 ${gtmTagVariable}_LiveCmeCardV2`}
          onClick={click}
        >
          {reactHtmlParser(title)}
        </h4>
        {session_doctor_entities?.length > 0 && (
          <DoctorsSectionForCard
            className="ps-0"
            cardData={{ session_doctor_entities }}
            type="session"
            // id={id}
            gtmTagVariable={`${gtmTagVariable}_LiveCmeCardV2`}
          />
        )}
        {!withOutButton && isButton && (
          <div className="w-100 float-start cardV1Ftr d-flex align-items-center justify-content-between mt-2">
            <div className="cardV1FtrBtn rippleEffect rounded cursorPointer d-inline-block overflow-hidden py-3 px-4">
              {/* <div
                className="cardV1BtnHover position-absolute top-50 start-50 translate-middle"
                style={{ backgroundColor: '#cc4daa' }}
              ></div>
              <div
                className="cardV1BtnBorder rounded position-absolute start-0 top-50 translate-middle-y"
                style={{ borderColor: '#cc4daa' }}
              ></div>
              <span className="position-relative z-1" style={{ color: '#cc4daa' }}>
                Get Recording
              </span> */}
            </div>
            <div
              className="cardV1FtrBtn cardV1FtrBtn2 rippleEffect rounded cursorPointer d-inline-block overflow-hidden py-3 px-4 text-white"
              onClick={click}
            >
              <div
                className="cardV1BtnHover position-absolute top-50 start-50 translate-middle"
                style={{ backgroundColor: '#cc4daa' }}
              ></div>
              <div
                className="cardV1BtnBorder rounded position-absolute start-0 top-50 translate-middle-y"
                style={{ borderColor: '#cc4daa' }}
              ></div>
              <span className={`${gtmTagVariable} position-relative z-1 d-flex`}>
                {session_status == 3 || session_status == 6 ? ' View Details' : ' Attend'}
                <MdOutlineArrowRightAlt
                  customClass={`fs-2 text-white ms-2 ${gtmTagVariable}_LiveCmeCardV2_attend`}
                />
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default memo(LiveCmeCardV2);
